import { render, staticRenderFns } from "./bindGoods.vue?vue&type=template&id=22080464&scoped=true"
import script from "./bindGoods.vue?vue&type=script&lang=js"
export * from "./bindGoods.vue?vue&type=script&lang=js"
import style0 from "./bindGoods.vue?vue&type=style&index=0&id=22080464&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22080464",
  null
  
)

export default component.exports